import { render, staticRenderFns } from "./viewAttachedDocs.vue?vue&type=template&id=63ab57a6&scoped=true&"
import script from "./viewAttachedDocs.vue?vue&type=script&lang=js&"
export * from "./viewAttachedDocs.vue?vue&type=script&lang=js&"
import style0 from "./viewAttachedDocs.vue?vue&type=style&index=0&id=63ab57a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab57a6",
  null
  
)

export default component.exports